module.exports = __webpack_public_path__ + "media/src/Quiz/sandbox/questionPortrait-14e318093b421d86ab48c7725b92a221.jpg";